import Vue from 'vue'
import Vuex from 'vuex'
import {supabase} from '../supabase'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loggedIn: false,
    userProfile: null,
    alert: {alert: false},
    userLoading: false, 
    up: false,
    setupTotp: false,
    verifyTotp: false,
    mLogin: false
  },
  getters: {
    loggedIn (state) {
      return state.loggedIn
    },
    mLogin (state) {
      return state.mLogin
    },
    setupTotp (state) {
      return state.setupTotp
    },
    verifyTotp (state) {
      return state.verifyTotp
    },
    loadedUser (state) {
      return state.userProfile
    },
    loadedAlert (state) {
      return state.alert
    },
    loadedUserLoading (state) {
      return state.userLoading
    },
    updatePassword (state) {
      return state.up
    }
  },
  mutations: {
    SET_LOGGED_IN(state, payload) {
      state.loggedIn = payload;
    },
    SET_M_LOGIN(state, payload) {
      state.mLogin = payload;
    },
    SET_SETUP_TOTP(state, payload) {
      state.setupTotp = payload 
    },
    SET_VERIFY_TOTP(state, payload) {
      state.verifyTotp = payload 
    },
    SET_USER(state, payload) {
      state.userProfile = payload
    },
    SET_UP(state, payload) {
      state.up = payload
    },
    setAlert (state, payload) {
      state.alert = payload
    },
    setUserLoading (state, payload) {
      state.userLoading = payload
    }
  },
  actions: {
    async getUser({commit, state}) {
      if(state.userProfile) {
        return
      }
      commit('setUserLoading', true)
      if(!state.userProfile) {
        const { data: { user } } = await supabase.auth.getUser()
        const { data, error } = await supabase.from('users').select('*').eq('uid', user.id)
        if(data) {   
            if(data[0].deleted) {
              supabase.auth.signOut()
              alert('ID not found or deleted')
              return
            }
            if(data[0].status === 'REJECTED'){
              supabase.auth.signOut()
              alert('ID not found')
              return
            }
            commit('SET_USER', data[0])
            commit('setUserLoading', false)
        }
        if(error) {
            //dispatch('createAlert',{type: 'error', message: error.message})
            console.log(error);
        }
      }
  },

  createAlert ({commit}, payload) {
    const data = {
        alert: true,
        type: payload.type,
        message: payload.message
    }
    commit('setAlert', data)
    setTimeout(() => {
        commit('setAlert', {alert: false})
    }, 3000);
},

  
},
  modules: {
  }
})
